var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "订单取消",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "pram", attrs: { model: _vm.pram, "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "取消原因：",
                    prop: "cancelRemark",
                    rules: [
                      {
                        required: true,
                        message: "请填写取消原因",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      resize: "none",
                      placeholder: "取消原因",
                    },
                    model: {
                      value: _vm.pram.cancelRemark,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "cancelRemark", $$v)
                      },
                      expression: "pram.cancelRemark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.handerSubmit("pram")
                    },
                  },
                },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }